/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-03 12:11:44
 * @FilePath: \eu-eswop-official-site\src\locales\index.js
 * @Description:
 */

import ElementUI from 'element-ui'
import iviewDE from 'element-ui/lib/locale/lang/de.js'
import iviewEN from 'element-ui/lib/locale/lang/en.js'
import iviewES from 'element-ui/lib/locale/lang/es.js'
import iviewZH from 'element-ui/lib/locale/lang/zh-CN.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from './lang/de.js'
import en from './lang/en.js'
import es from './lang/es.js'
import zh from './lang/zh.js'

const hash = window.location.hash;
const queryString = hash.split('?')[1];
const urlParams = new URLSearchParams(queryString);

// 优先使用 lang 参数，如果没有则根据 channelId 判断，默认使用 'es'
const langParam = urlParams.get('lang');
const channelId = urlParams.get('channelId') || sessionStorage.getItem('channelId');

// 根据渠道判断默认语言：奥地利渠道用德语，其他用西班牙语
const getDefaultLangByChannel = () => {
  if (channelId === '100070' || channelId === '100080') {
    return 'de'; // 奥地利线上/线下渠道默认使用德语
  }
  return 'es'; // 默认渠道使用西班牙语
};


// 简化：只取 langParam 中下划线前的部分作为语言代码
const getLanguageFromParam = (param) => {
  if (!param) {
    return 'es';
  }

  // 获取语言代码（如果包含下划线，取第一部分）
  let langCode = param.includes('_') ? param.split('_')[0] : param;

  // 转换为小写
  langCode = langCode.toLowerCase();

  // 检查是否是已知的语言代码
  const knownLanguages = ['en', 'es', 'de'];
  if (knownLanguages.includes(langCode)) {
    return langCode;
  }

  // 如果是奥地利相关的参数（如 'at', 'AT'），返回德语
  if (langCode === 'at') {
    return 'de';
  }

  // 如果不是已知语言，返回默认英语
  return 'es';
};

// 确定最终使用的语言（优先级：URL 参数 > 渠道默认 > 英语）
const finalLang = langParam ? getLanguageFromParam(langParam) : getDefaultLangByChannel();

console.log('finalLang', finalLang)

Vue.use(VueI18n)

const localeMapping = {

  zh: {
    name: 'ZH',
    value: 'zh',
    langFile: zh,
    iViewLangeFile: iviewZH,
    acceptLanguage: 'zh_CN'
  },

  en: {
    name: 'EN',
    value: 'en',
    langFile: en,
    iViewLangeFile: iviewEN,
    acceptLanguage: 'en_US'
  },

  es: {
    name: 'ES',
    value: 'es',
    langFile: es,
    iViewLangeFile: iviewES,
    acceptLanguage: 'es_ES'
  },

  de: {
    name: 'DE',
    value: 'de',
    langFile: de,
    iViewLangeFile: iviewDE,
    acceptLanguage: 'de_DE'
  }

};

const defaultLang = finalLang;
const lang = finalLang;
const isES = lang === 'es';

console.log(lang)

// 设置后台语言的请求头
const customRequestHeader = {
  'Accept-Language': localeMapping[lang]?.acceptLanguage || 'en_US',
  'name': localeMapping[lang]?.name || 'EN'
};
const i18n = new VueI18n({
  locale: lang
})

// 确保语言在 localeMapping 中存在，如果不存在则使用英语
const selectedLang = localeMapping[lang] ? lang : 'EN';
i18n.setLocaleMessage(selectedLang, Object.assign(localeMapping[selectedLang]?.langFile, localeMapping[selectedLang]?.iViewLangeFile))

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const vm = new Vue({ i18n })

// 切换语言方法
Vue.prototype.$toggleLang = (lang = defaultLang) => {
  sessionStorage.setItem('lang', lang)
  window.location.reload()
}

if (window.location.hostname !== 'localhost') {
  // 本地开发展示中文
  delete localeMapping.zh
}
export {
  customRequestHeader,
  i18n,
  isES,
  lang,
  localeMapping,
  vm
}